export const QUERY_KEY_SINGLE_VOYAGES = 'base_single_voyages'
export const QUERY_KEY_PAGINATION_SIMPLE_SINGLE_VOYAGES = 'pagination_simple_single_voyages'
export const QUERY_KEY_SINGLE_VOYAGE_BY_ID = 'base_single_voyage_by_id'